import { useEffect } from 'react';
import { redirectToErp } from 'constants/auth';

function LoginRedirect() {
  useEffect(() => {
    redirectToErp();
  }, []);

  return null;
}

export default LoginRedirect;
